import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import { v4 as uuidv4 } from 'uuid';
import Utils from '../utils';
import { Capability, InternalCapability } from '../data/account';

const { Session } = Utils;

export default class Util {
	// Process CarrierAgreements in AccountInfo, based on configured carriers for the user
	static getCarrierAgreements() {
		const {
			CarrierCustomsAgreements = '{}',
			UspsTermsAlwaysAgree = '',
		} = Session.getPreferences();
		const carrierAgreements =
			CarrierCustomsAgreements !== '' ? JSON.parse(CarrierCustomsAgreements) : {};

		/*
		 * Add USPS by default if there are no carriers specified (default preference value),
		 * or if UspsTermsAlwaysAgree preference for the user is true.
		 */
		if (isEmpty(carrierAgreements)) {
			carrierAgreements.USPS = UspsTermsAlwaysAgree === 'true';
		}

		// If the UPS agreement was not accepted before, update preferences to false for UPS, but only if user is able to print ups
		if (
			Session.hasCapability(Capability.UpsIntl) &&
			(Session.hasCapability(InternalCapability.DisplayUpsByDefault) ||
				this.isCarrierConfigured('UPS')) &&
			carrierAgreements.UPS !== true
		) {
			carrierAgreements.UPS = false;
		}

		return carrierAgreements;
	}

	// Check if the user has accepted all carrier agreements.
	static hasUserAcceptedAllCarrierAgreements() {
		const accountInfo = Session.getAccountInfo();
		const configuredCarriers = isArray(accountInfo.configuredCarriers)
			? accountInfo.configuredCarriers
			: [];
		const carrierAgreements = this.getCarrierAgreements();

		if (!carrierAgreements.USPS) {
			return false;
		}

		for (const record of configuredCarriers) {
			if (carrierAgreements[record.Carrier] === false) {
				return false;
			}
		}

		return true;
	}

	static updatedCarrierAgreements(bool) {
		const carrierAgreements = this.getCarrierAgreements();

		return Object.keys(carrierAgreements).reduce(
			(_carrierAgreements, key) => ({
				..._carrierAgreements,
				[key]: bool,
			}),
			{}
		);
	}

	static isCarrierConfigured(carrierName) {
		const accountInfo = Session.getAccountInfo();
		const configuredCarriers = isArray(accountInfo.configuredCarriers)
			? accountInfo.configuredCarriers
			: [];

		if (configuredCarriers.length === 0) {
			return false;
		}

		return configuredCarriers.map(obj => obj.carrier).includes(carrierName);
	}

	static createAddCarrierToLocationsRequest(enterpriseLocations, carrier) {
		return {
			AdminUserId: Session.getAccountInfo().userId,
			CustIds: enterpriseLocations.map(location => location.CustId),
			Parameters: {
				UserOwnedAccount: false,
				Carrier: carrier,
				AgreeToEula: true,
			},
			MaxErrors: 1,
			CorrelationId: uuidv4(),
		};
	}
}
